// Single front door for every site form submission.
//
// Interim backend: FormSubmit (https://formsubmit.co), a free, no-account
// relay that emails each submission. It needs no server or secret; the
// destination lives in the endpoint URL. Submissions go to Daniel with Josh
// CC'd (both @popprotents.com).
//
// One-time activation: the very first submission triggers a confirmation
// email to the primary address, someone must click its link before delivery
// starts. After activation, FormSubmit issues a random alias we can swap in
// below to keep the raw address out of the page source.
//
// "Own later": this whole module gets swapped for a Cloudflare Pages Function
// + Resend once Josh has that set up, the three forms call submitForm() and
// won't need to change.

const PRIMARY = 'daniel@popprotents.com';
const CC = 'josh@popprotents.com';
const ENDPOINT = `https://formsubmit.co/ajax/${PRIMARY}`;

export interface SubmitOptions {
  /** Email subject line, e.g. "New Rental Quote Request, Pop Pro Tents". */
  subject: string;
  /** Flat field map to include in the email (label → value). */
  data: Record<string, string>;
  /** Submitter's email, used as Reply-To so a reply reaches the customer. */
  replyTo?: string;
}

export async function submitForm({ subject, data, replyTo }: SubmitOptions): Promise<boolean> {
  const payload: Record<string, string> = {
    ...data,
    _subject: subject,
    _cc: CC,
    _template: 'table',
    _captcha: 'false',
    // Honeypot: FormSubmit discards the submission server-side if this is
    // ever filled. Always sent empty from real submissions.
    _honey: '',
  };
  if (replyTo) payload._replyto = replyTo;

  try {
    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const json = (await res.json().catch(() => null)) as { success?: boolean | string } | null;
    return res.ok && (json?.success === true || json?.success === 'true');
  } catch {
    return false;
  }
}
